import { BatchToggleField } from 'components/common-form/builder/form/node/field/BatchToggleField';

import type { ProductNodeBuilderProps } from '../../ProductNodeBuilder.model';

export function BatchMultipleApplyToggleField(props: ProductNodeBuilderProps) {
  return (
    <BatchToggleField
      {...props}
      switchSize="md"
      useFormControlStyle={false}
      useEditedStyle={true}
      withStateLabel={false}
    />
  );
}
